import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationFR from './locales/fr.json';
import translationEN from './locales/en.json';
import translationJP from './locales/jp.json';

const resources = {
  fr: { translation: translationFR },
  en: { translation: translationEN },
  jp: { translation: translationJP }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en', 'jp'],
    nonExplicitSupportedLngs: true, // fr-FR -> fr, en-US -> en
    debug: false,
    detection: {
      // Le navigateur d'un visiteur japonais renvoie « ja » / « ja-JP », mais nos
      // clés utilisent « jp ». On mappe pour qu'il voie le japonais dès la 1re visite.
      convertDetectedLanguage: function (lng) {
        return String(lng).toLowerCase().indexOf('ja') === 0 ? 'jp' : lng;
      }
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;